<div class="tab-content" [class.loading]="isContentLoading">
  @if (isContentLoading) {
    <i class="fa-solid fa-spinner fa-spin tab-loading-spinner"></i>
  }
  @if (!isContentLoading && canViewAccountSettings) {
    <p class="double-margin-bottom">
      Choose which account notifications you receive and who they're sent to. Each notification type is managed in its
      own section below.
    </p>

    <!-- Billing notifications: who on the account receives capacity/overage/billing alerts -->
    <section class="notification-section">
      <div class="flex justify-between items-center section-heading">
        <h3>Billing notifications</h3>
        <p-iconfield class="filter-container">
          <input pInputText #filterInput type="text" (input)="filterGlobal($event)" placeholder="Search..." />
          @if (!isFilterApplied) {
            <p-inputicon class="fa-utility-fill fa-semibold fa-filter fade-icon" />
          } @else {
            <p-inputicon
              (click)="clearInput()"
              (keydown.enter)="clearInput(); $event.preventDefault()"
              (keydown.space)="clearInput(); $event.preventDefault()"
              class="fa-utility fa-semibold fa-xmark"
              role="button"
              tabindex="0"
              aria-label="Clear search"
            />
          }
        </p-iconfield>
      </div>
      <p class="section-description">
        Alerts about your account's resource capacity, overage, and billing. You can manage your own subscription to
        these notifications, and see which other account users are subscribed.
      </p>

      <div class="table-container">
        <div class="table-section main-table">
          <p-table
            #subscribersTable
            [value]="subscribers"
            [globalFilterFields]="['name', 'email']"
            dataKey="accountSubjectId"
            class="p-datatable-sm arp-prime-datatable"
            [rowHover]="true"
            [paginator]="false"
            [rowTrackBy]="subscriberTrackBy"
          >
            <ng-template #header>
              <tr>
                <th pSortableColumn="name" class="strong-text">Name</th>
                <th pSortableColumn="email" class="strong-text">Email</th>
                <th class="strong-text billing-column">Billing notifications</th>
              </tr>
            </ng-template>
            <ng-template #body let-row>
              <tr [ngClass]="{ 'default-role-row': row.isYou }">
                <td>{{ row.name }}{{ row.isYou ? ' (You)' : '' }}</td>
                <td>{{ row.email }}</td>
                <td class="billing-column">
                  @if (row.isYou) {
                    <p-toggleswitch
                      [(ngModel)]="row.subscribed"
                      (onChange)="onToggleSubscription(row)"
                      ariaLabel="Receive billing notifications"
                    ></p-toggleswitch>
                  } @else {
                    <span class="subscription-status" [class.receiving]="row.subscribed">{{
                      row.subscribed ? 'Receiving' : 'Off'
                    }}</span>
                  }
                </td>
              </tr>
            </ng-template>
            <ng-template #emptymessage>
              <tr>
                <td colspan="3" class="subscription-empty">No account users match your search.</td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>

      @if (subscribedCount === 0) {
        <div class="notice-warning subscriber-notice">
          <i class="fa-utility fa-semibold fa-circle-exclamation"></i>
          <p>
            <strong>No one is subscribed.</strong> At least one account user should receive billing notifications so
            capacity alerts don't go unseen.
          </p>
        </div>
      }

      <p class="section-footnote">
        <i class="fa-solid fa-users"></i>
        <span>Manage account users in <a [routerLink]="userManagementLink">User Management</a>.</span>
      </p>
    </section>
  }
</div>
